export { default as default } from './LoadingPage';
